module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Bold.c5540c77.eot";